import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-navy/60 font-serif text-2xl">Loading…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname + location.search + location.hash }} />;
  // Superadmin implicitly satisfies any admin-restricted route.
  const allowed = roles && roles.includes("admin") ? [...roles, "superadmin"] : roles;
  if (allowed && !allowed.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
